import { useMapContext } from '../map/context/MapContext';
import { useCallback, useEffect, useState } from 'react';

export const useMapZoom = () => {
  const { map } = useMapContext();
  const [zoom, setZoom] = useState<number>(-1);

  const onChangeCallback = useCallback(() => {
    if (!map) return;
    setZoom(map.getView().getZoom() ?? -1);
  }, [map]);

  useEffect(() => {
    if (!map) return;
    map.getView().on('change:resolution', onChangeCallback);
    // Set initial zoom
    setZoom(map.getView().getZoom() ?? -1);
    return () => {
      map.getView().un('change:resolution', onChangeCallback);
    };
  }, [map, onChangeCallback]);

  return zoom;
};
